'use strict';

var angular = require('angular');
//Remove this line
module.exports = angular.module('AVRO.Common.Cog', []).directive('rmCogMenu', require('./directives/CogMenuDirective')).controller('CogMenuController', require('./controllers/CogMenuController'));